import { Type } from 'class-transformer';

export class SideNavMenuInfo {
  name: string;
  text: string;
  path?: string;
  icon?: string;
  value?: string;
  selected?: boolean = false;
  expanded?: boolean = false;
  @Type(() => SideNavMenuInfo)
  items?: SideNavMenuInfo[];
  dynamic?: boolean = false;
  badge?: string;

  static create(
    name: string,
    text: string,
    path?: string,
    icon?: string,
    selected?: boolean,
    dynamic?: boolean,
    items?: SideNavMenuInfo[],
    badge?: string
  ): SideNavMenuInfo {
    const info = new SideNavMenuInfo();
    info.name = name;
    info.text = text;
    info.path = path || undefined;
    info.icon = icon || undefined;
    info.value = name;
    info.selected = selected === true;
    info.items = items || undefined;
    info.dynamic = dynamic === true;
    info.badge = badge || undefined;
    return info;
  }
}
